import script from "./DropdownArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownArrow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__